import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const TooltipContainer = styled(Flex)`
    ${setFontVariant("body2", carbon[500])};
    gap: 9px;
    align-items: center;
    min-width: 149px;
    justify-content: space-between;
`;

export const ChartWrapper = styled.div`
    width: calc(100% + 56px);
    margin-left: -28px;
    margin-right: -28px;
`;
